<template>
  <div class="w-fit h-9 bg-white rounded-md py-2 text-md font-semibold flex items-center justify-center gap-2 cursor-pointer" :class="$props.iconOnly ? 'px-2' : 'px-4'">
    <slot></slot>
  </div>
</template>

<script lang="ts">
export default {
  name: "ButtonComponent",
  props: {
    iconOnly: {
      type: Boolean,
      default: false
    }
  }
};
</script>